import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useIsMobile } from 'hooks/useIsMobile'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { encodeStorage, removeStorage } from 'functions/storageBase64'
import { dataLayerButtons } from 'functions/dataLayerFunction'


export function BtnPlanGlobal(props){
    const {
        cardending,
        typeButton,
        nameButton,
        elegirPlan,
        clickToPay,
        textButton = "Elegir planes a pagar"
    } = props

    const { isMobile } = useIsMobile()
    const history = useHistory()

    removeStorage('cardendingPayment')
    removeStorage('noInternetPayment')

    const handlePagarTarjeta = () => {
        handleTarjetaCredito()
        clickToPay()
    };


    const handleTarjetaCredito = () => {
        encodeStorage('cardendingPayment', cardending)
        dataLayerButtons({ eventName: "credito_pagar" })
        encodeStorage('ShowMultiplan', `${elegirPlan}`)
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
    };

    return(
        isMobile
            ? isMobile === 'desktop'
                ?
                    <div className="boxBtnPagarDsk">
                        <button onClick={handlePagarTarjeta}>{nameButton ? nameButton : textButton}</button>
                    </div>
                :
                    typeButton === "inline"
                        ?
                            <button className="btnOpcT borderLeftOpc" onClick={handlePagarTarjeta}>{nameButton ? nameButton : textButton}</button>
                        :
                            <div className="boxButtonPagar">
                                <button onClick={handlePagarTarjeta} className="btnPagar">{nameButton ? nameButton : textButton}</button>
                            </div>
            : null
    )
}

export function ElegirPlan(props) {
    const {
        cardending,
        typeButton,
        textButton
    } = props

    const clickToPay = () => {
        // console.log('clickToPay ElegirPlan')
        encodeStorage('clickToPay', "ElegirPlan")
    }

    return (
        <BtnPlanGlobal 
            cardending={cardending}
            typeButton={typeButton}
            elegirPlan={false}
            textButton={textButton}
            clickToPay={clickToPay}
        />
    )
}

export function PagarPlan(props) {
    const {
        cardending,
        typeButton,
        nameButton
    } = props

    const clickToPay = () => {
        // console.log('clickToPay PagarPlan')
        encodeStorage('clickToPay', "PagarPlan")
    }

    return (
        <BtnPlanGlobal 
            cardending={cardending}
            typeButton={typeButton}
            nameButton={nameButton}
            elegirPlan={false}
            clickToPay={clickToPay}
        />
    )
}